import { has } from "lodash";
import { Descendant, Element, Node, Text } from "slate";

const VOID_ELEMENT_TYPES = ["image", "mention", "textVariable"];

export function isRichTextMessageEmpty(richTextMessage: Descendant[]): boolean {
  const hasContentVoids = richTextMessage.some(node =>
    Array.from(Node.nodes(node)).some(
      ([itNode]) => Element.isElement(itNode) && VOID_ELEMENT_TYPES.includes(itNode.type as string)
    )
  );

  return (
    !hasContentVoids &&
    richTextMessage
      .map(node => Node.string(node))
      .join("")
      .trim().length === 0
  );
}

export function isMessageEmpty(message: string | Descendant[]): boolean {
  if (typeof message === "string") {
    return message.length === 0;
  }
  return isRichTextMessageEmpty(message);
}

export const isTextNode = (node: Descendant): node is Text => Text.isText(node);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const extractResourceIDsFromRichTextObj = (nodes: Descendant[]) => {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const resourceIDs: any = [];

  if (!nodes || !Array.isArray(nodes)) {
    return resourceIDs;
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  function traverseNodes(nodes: any) {
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    nodes.forEach((node: any) => {
      if (typeof node === "object" && has(node, "resourceID")) {
        resourceIDs.push(node.resourceID);
      }

      if (node.children && Array.isArray(node.children)) {
        traverseNodes(node.children);
      }
    });
  }

  traverseNodes(nodes);

  return resourceIDs;
};
